export const createMapOptions = (): google.maps.MapOptions => {
  if (typeof window === 'undefined' || !window.google) {
    return {};
  }

  const { ControlPosition, MapTypeControlStyle } = window.google.maps;

  return {
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: ControlPosition.BLOCK_START_INLINE_END
    },
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: MapTypeControlStyle.HORIZONTAL_BAR,
      position: ControlPosition.BLOCK_START_INLINE_START
    },
    streetViewControl: true,
    streetViewControlOptions: {
      position: ControlPosition.RIGHT_BOTTOM
    },
    cameraControl: true,
    cameraControlOptions: {
      position: ControlPosition.INLINE_END_BLOCK_END
    }
  };
};
